import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { NavLink, useNavigate  } from "react-router-dom";
import { DDD,
        E2Data,
        copyExistingToNew,
        getInvoiceValuesFromMergedDDDIAndUI} from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import classes from "./IntegrationWizard.module.scss";
import { useQuery } from "@tanstack/react-query";
import ActiveInvoicePicker from "../components/integrationWizard/ActiveInvoicePicker";
import Steps from "../components/integrationWizard/Step/Steps";
import { UserUIStateContext } from "../store/userUIStateContext";
import { OrgIdContext } from "../store/orgId_context";
import InvoiceDisplayIframe from "../components/integrationWizard/InvoiceDisplayIframe";
import Button from "../components/UI/Button";
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import ForwardIcon from '@mui/icons-material/Forward';
import LooksOneIcon from '@mui/icons-material/LooksOne';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2data = new E2Data("EU_Invoices");
//data.filter='DeviceId__AssignedTo="CKI"  AND DeviceId__Integration=true';

const IntegrationSteps = () => {
    const [currentInvoiceId, setCurrentInvoiceId] =  useState(/*"44de78e7-94fc-11ee-9108-ee67f6910206"*/);
    const {saveValues, integrationData, setIntegrationDataHandler} = useContext(UserUIStateContext);
    const { integrationDevice} = useContext(OrgIdContext);
    const [executeResponse, setExecuteResponse] = useState();
    const navigate = useNavigate();


    useEffect(() =>{
        console.log(integrationData);
        if(!currentInvoiceId && integrationData?.currentInvoiceId)
            setCurrentInvoiceId(integrationData.currentInvoiceId);
    },[integrationData]);

    const onInvoiceSelected = (invoice) => {
        setCurrentInvoiceId(invoice.Id);
        loadNewInvoiceAsActive(invoice.Id);
    }

    const loadNewInvoiceAsActive = (id) => {
        const ddd = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        ddd.APP_GetNewAndExisting({Complexity:"Normal"}, id).then(res => {
            const invoice = res?.DDDI_GetNew?.Invoice?.Invoice;
            const existing = res?.UI_GetExisting?.Invoice;
            if(!invoice || !existing)
                return console.error("No existing or new invoice found. Stopped loading UI state");
            const newInvoice = copyExistingToNew(invoice, existing);

            if(newInvoice)
                setIntegrationDataHandler({...integrationData, currentInvoiceId:id, invoiceJson:{Object : newInvoice, Complexity : "Normal"}});
        }).catch(err => {
            console.error(err);
        });
    }

    const onExecute = (res) => {
        setExecuteResponse(res);
    }

    const onCreateNew = () =>{
        setIntegrationDataHandler({...integrationData, currentInvoiceId:null});
        navigate("/integration-wizard");
    }

    return(
        <>
        <Helmet>
            <title>Integration Steps | DDD Invoices</title>
        </Helmet>
        <div className={`w-100 h-100 ${classes.container} ${classes["p-lrb-5"]}`}>
            <div className="flex d-flex">
                <div className={classes["blankTitle"]}>Active invoice</div>
                <div style={{marginLeft: "auto", paddingRight:"0.5rem", marginTop:"1rem", whiteSpace:"nowrap"}}>
                    {currentInvoiceId && <NavLink to="/integration-wizard" state={{activeTab:"edit"}}><Button id="activeInvoiceBtn" style={{marginRight:"1rem"}}><ForwardIcon style={{marginRight:"1rem", transform:"rotate(180deg)"}}/>Edit invoice<LooksOneIcon style={{marginLeft:"1rem"}}/></Button></NavLink>}
                    <NavLink to="/integration-wizard-return"><Button id="activeInvoiceBtn" style={{marginRight:"1rem"}}><Looks3Icon style={{marginRight:"1rem"}}/>How to get invoice documents<ForwardIcon style={{marginLeft:"1rem"}}/></Button></NavLink>
                </div>
            </div>
                <ActiveInvoicePicker invoiceId={currentInvoiceId} onCreateNew={onCreateNew} onInvoiceSelected={onInvoiceSelected} onExecuteResponse={executeResponse}/>
            <div className={classes["blankTitle"]}>Steps</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                <Steps invoiceId={currentInvoiceId} onExecute={onExecute}/>
            </div>
            <div className={classes["blankTitle"]}>Invoice</div>
            <div style={{height:"100vh"}}>
                <InvoiceDisplayIframe invoiceId={currentInvoiceId} onExecuteResponse={executeResponse}/>
            </div>
        </div>
        </>
    )
}
export default IntegrationSteps;